<template>
  <div class="wrap">
    <div class="left"></div>
    <div class="right">
      <div class="loginBox">
        <div class="logo"><img src="@/assets/image/logo.png" alt=""></div>
        <div class="username">
          <span class="name">账号</span><span class="nameEnglish">Sign in</span>
          <div class="int">
            <el-input v-model="form.username" placeholder="请输入电子邮箱"></el-input>
          </div>
        </div>
        <div class="username">
          <span class="name">密码</span><span class="nameEnglish">password</span>
          <div class="int">
            <el-input v-model="form.password" placeholder="请输入密码"></el-input>
          </div>
        </div>
        <div class="btn">
          <el-button class="buttint">登录</el-button>
        </div>
        <div class="check">
          <div><el-checkbox v-model="checked">下次自动登录</el-checkbox></div>
          <div class="forget" @click="goForget">忘记密码?</div>
        </div>

        <div class="register">
          <div class="line"></div>
          <div class="name" @click="goRegister">立即注册</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      checked:false
    }
  },
  methods:{
    goForget(){
      this.$router.push("/Forget")
    },
    goRegister(){
      this.$router.push("/register")
    },
  }
}
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;
  display: flex;

  .left {
    width: 60%;
    height: 100vh;
    background: url('../../assets/image/leftImg.png') no-repeat;
    background-position: center;
    background-size: cover;
  }

  .right {
    width: 40%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .loginBox {
      width: 40%;
      height: 50vh;

      .logo {
        width: 100%;
        padding: 30px 0;
        display: flex;
        justify-content: center;
      }

      .username {
        text-align: left;
        width: 100%;

        .name {
          font-weight: bold;
        }

        .nameEnglish {
          padding-left: 20px;
          font-size: 14px;
        }
        .int{
          padding: 10px 0;
        }
      }
      .btnbox{

      }
      .btn{
        width: 100%;
        padding: 30px 0;
        .buttint{
          width: 100%;
          background-color: #25877d;
          color: #ffffff;
        }
      }
      .check{
        width: 100%;
        display: flex;
        justify-content: space-between;
        .forget{
          font-size: 14px;
          cursor: pointer;
        }
      }
      .register{
        width: 100%;
        height: 60px;
        align-items: center;
        display: flex;
        .line{
          width: 25%;
          height: 6px;
          background-color: #25877d;
        }
        .name{
          width: 50%;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Login/index.vue